const welcomeSchema = {
  description: '',
  rightText: '',
  video: '',
};

export default welcomeSchema;
